import { useContext } from 'react';
import { Context } from '../Provider';

const usePageInfo = () => {
  const context = useContext(Context);
  return context.pageInfo;
};

export default usePageInfo;
